import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleMake.Find.IRequest;
type Response = Api.Core.VehicleMake.Find.IResponse;
type Headers = Api.Core.VehicleMake.Find.IHeaders;
const url = '/api/ProductManagement/VehicleMake/:id';
export default async function vehicleMakeFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
